import { render, staticRenderFns } from "./ssyIssuedeptinfo.vue?vue&type=template&id=4a1bc3e6&scoped=true&"
import script from "./ssyIssuedeptinfo.vue?vue&type=script&lang=js&"
export * from "./ssyIssuedeptinfo.vue?vue&type=script&lang=js&"
import style0 from "./ssyIssuedeptinfo.vue?vue&type=style&index=0&id=4a1bc3e6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1bc3e6",
  null
  
)

export default component.exports